module.exports = __webpack_public_path__ + "img/lite-kids.84e8db50.jpg";